module.exports = __webpack_public_path__ + "_assets/img/Frame1210.91a6e626.svg";